'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicAccountTypes = require('@gig/magic-account-types');
var tslib = require('tslib');
var magicMessages = require('@gig/magic-messages');

function getTwoFactorAuthModes(twoFactorAuthModesString) {
    return magicAccountTypes.sanitizeTwoFactorAuthModes(twoFactorAuthModesString);
}
function isTwoFactorAuthOptionEnabled() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var twoFactorAuthModesString, twoFactorAuthModes;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTwoFactorAuthOption()];
                case 1:
                    twoFactorAuthModesString = _a.sent();
                    twoFactorAuthModes = getTwoFactorAuthModes(twoFactorAuthModesString);
                    return [2 /*return*/, twoFactorAuthModes.some(function (value) { return value !== magicAccountTypes.TwoFactorAuthMode.NONE; })];
            }
        });
    });
}
function getTwoFactorAuthOption() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, magicCommon.getFeatureValueV2(magicMessages.Feature.TWO_FACTOR_AUTHENTICATION_SIGN_UP, magicAccountTypes.TwoFactorAuthMode.NONE)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}

exports.isTwoFactorAuthOptionEnabled = isTwoFactorAuthOptionEnabled;
